export default __webpack_public_path__ + "static/media/ic-twitter.edd21cbf.svg";